import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../api/axiosBaseQuery";

// src/services/authService.js
  

  export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: axiosBaseQuery,
    endpoints: (builder) => ({
      login: builder.mutation({
        query: (data) => ({
          url: '/auth/login',
          method: 'POST',
          data,
        }),
      }),
      register: builder.mutation({
        query: (data) => ({
          url: '/users/register',
          method: 'POST',
          data,
        }),
      }),
      forgotPassword: builder.mutation({
        query: (data) => ({
          url: "/auth/password-reset",
          method: "POST",
          data,
        }),
      }),
     
      resetPassword: builder.mutation({
        query: (data) => ({
          url: "/auth/password-reset/confirm",
          method: "POST",
          data,
        }),
      }),
    }),
  })
  
  // Export hooks for usage in functional components, which are
  // auto-generated based on the defined endpoints
  export const { useLoginMutation, useRegisterMutation,useForgotPasswordMutation,useResetPasswordMutation, } = authApi
  
  export default authApi;